export enum ActionHint {
  BLANK = 'BLANK',
  FOLD = 'FOLD',
  CHECK = 'CHECK',
  BET = 'BET',
  RAISE = 'RAISE',
  CALL = 'CALL',
  ALLIN = 'ALLIN'
}

export type BotAction = {
  action: ActionHint
  amount: number
}

export const BOT_KINDS = ['BOT_PP'] as const

export const BOT_NAMES = [
  'TanyaCMing',
  'Samantha Bricker',
  'Carol Schulz',
  'Georgia KOO',
  'AnteAnnie54',
  'AllInAmy99',
  'Lucia Greene',
  'Zoe Reed99',
  'Penelope Baker',
  'Stella Writes',
  'Harper Rodriguez',
  'Isa Jones',
  'Kansas Caterina',
  'Ellie Bronco',
  'Victoria Titans',
  'Lucy Lulu',
  'Stella Giant',
  'Brookie Charger',
  'Bebe WM',
  'MandyB',
  'VeronicaH',
  'Lanie',
  'Sharon V',
  'Greta',
  'Marcie',
  'Finny',
  'Ursula',
  'Maria L',
  'Evelyn Smith',
  'Rachel M',
  'Malorie D',
  'JillyBean',
  'Babs',
  'Kara Sims',
  'Beth K',
  'Nikki Luck',
  'Paula Milner',
  'Claire C',
  'AlwaysLuckyTay',
  'Freya ',
  'Miss Athena',
  'Joan of Arc',
  'JayLo',
  'Katniss E',
  'Athena',
  'Ms.Maisel',
  'EllaMella',
  'Lilly KS',
  'Mia Mia',
  'Zoey Lloyd',
  'Ella Knows',
  'Gracely',
  'IVYGEE',
  'Maya Price',
  'Nora Bee',
  'Jade',
  'MuseMia',
  'Ivy Belle',
  'Sparkle',
  'Luna',
  'Hailee K.',
  'Ms.Potter',
  'Kansas Queen',
  'CocoCharm',
  'VickyC',
  'Anne Grace',
  'Nicky M.',
  'Carmen',
  'Lina St.',
  'Emiko Zee',
  'Zahra Lei',
  'Banana Mama',
  'Orangina',
  'Sunny Side Up',
  'Evelyn Play',
  'Evie Que',
  'Queen Riley',
  'bLakeGame',
  'Lakers Queen',
  'Daisy Plays Poker',
  'Ava Garde',
  'ElleFitz',
  'Alex Plays',
  'Queen Aces',
  'Jazz Wizard',
  'Dani Dee',
  'Nina Q',
  'Boomer B',
  'Taro',
  'RC Queen',
  'ABBY'
]
export const THREE_CARD_BOT_NAMES = ['Jenny J', 'Taylor S']
